import React from 'react';
import { format } from 'date-fns';

const LoyaltyCardDetails = ({ card }) => {
    if (!card) return <p>No loyalty card associated with this customer.</p>;
    return (
        <div>
            <h2 className="text-xl font-semibold mb-4">Loyalty Card Details</h2>
            <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 rounded-lg shadow-md" role="alert">
                <p className="font-bold text-lg">Card Number: <span className="font-mono">{card.cardNumber}</span></p>
                <p className="text-3xl font-bold mt-2">{card.pointsBalance} Points</p>
                <p className="text-sm">Status: {card.status}</p>
            </div>
            <h3 className="text-lg font-semibold mt-6 mb-2">Points History</h3>
            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-2 text-left">Date</th>
                            <th className="px-4 py-2 text-left">Type</th>
                            <th className="px-4 py-2 text-right">Points</th>
                            <th className="px-4 py-2 text-left">Notes</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {card.transactions?.slice().reverse().map(tx => (
                            <tr key={tx._id}>
                                <td className="px-4 py-3 whitespace-nowrap text-sm">{format(new Date(tx.createdAt), 'dd-MM-yyyy')}</td>
                                <td className="px-4 py-3"><span className={`font-semibold ${tx.type === 'Earn' ? 'text-accent-green' : 'text-red-600'}`}>{tx.type}</span></td>
                                <td className="px-4 py-3 text-right font-bold">{tx.points}</td>
                                <td className="px-4 py-3 text-sm text-gray-600">{tx.notes}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LoyaltyCardDetails;